/* eslint-disable sonarjs/no-nested-conditional */
/* eslint-disable no-nested-ternary */
import React from 'react';
import { useTranslation } from 'react-i18next';

const CacheComponent = ({ report, beta }) => {
  const { t } = useTranslation();

  if (!(Array.isArray(report.cache_types) && Array.isArray(report.cache_cleared))) {
    return null;
  }

  return (
    <div className="further-details">
      {beta && <div className="border-b my-4 border-[#F4F5F7]" />}
      <h2>Further Details</h2>
      <table>
        <tbody>
          <tr>
            <th>Cache Type</th>
            <td>{report.cache_types.map((w) => t(`cache.${w.toLowerCase()}`)).join(', ')}</td>
          </tr>
          <tr>
            <th>Cleared?</th>
            {report.cache_cleared.includes('cleared') ? <td>Yes</td> : <td>No</td>}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default CacheComponent;
